import React, { Fragment, Component } from 'react';
import ReactDOM from 'react-dom';
class Portal extends Component {
    constructor(props) {
        super(props);
        this.modalRoot = document.getElementById('snackbar-root');
        this.el = document.createElement('div');
    }
    componentDidMount() {
        if (this.modalRoot)
            this.modalRoot.appendChild(this.el);
    }
    componentWillUnmount() {
        if (this.modalRoot)
            this.modalRoot.removeChild(this.el);
    }
    render() {
        const { children, className } = this.props;
        if (this.el)
            this.el.className = className;
        return (this.el && ReactDOM.createPortal(React.createElement(Fragment, null, children), this.el));
    }
}
export default Portal;
